/* eslint-disable */
import {BhImage} from './BhImage';
import {Ad} from './Ad';
/**
* @description Interface for Avensia.Commerce.Web.Models.Ads.ImageAd
*/
export interface ImageAd extends Ad {
	subTitle?: string;
	buttonCaption: string;
	buttonColor: string;
	image: BhImage;
}
export const isImageAd = (model: unknown): model is ImageAd => (model as ImageAd).component === 'Bygghemma.Commerce.Web.Models.Ads.ImageAd';

